import { render, staticRenderFns } from "./CsvDownload.vue?vue&type=template&id=2fdf0846&scoped=true&lang=pug&"
import script from "./CsvDownload.vue?vue&type=script&lang=ts&"
export * from "./CsvDownload.vue?vue&type=script&lang=ts&"
import style0 from "./CsvDownload.vue?vue&type=style&index=0&id=2fdf0846&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf0846",
  null
  
)

export default component.exports